import React, {useEffect, useState} from 'react';
import RestrictedNotice from "btdt/react/RestrictedNotice";
import LocationContact from "btdt/react/LocationContact";

export default function MaterialsStep({animating, simpleMode, chosenLocation, handleMaterialsChange, handleNextStep}) {

    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [otherMaterials, setOtherMaterials] = useState(null);

    useEffect(() => {
        if (selectedMaterial === 'Other' && otherMaterials) {
            handleMaterialsChange(`Other: ${otherMaterials}`)
        } else {
            handleMaterialsChange(selectedMaterial)
        }
    }, [selectedMaterial, otherMaterials])


    useEffect(() => {
        handleMaterialsChange(null)
    }, []);

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <div className="large-p">
                        What kind of material are you disposing of? (optional)
                    </div>
                    {chosenLocation?.restricted && chosenLocation.restricted.length > 0 && (
                        <div className={"lg:col-span-8 lg:col-start-3 mt-6"}>
                            <RestrictedNotice location={chosenLocation}/>
                        </div>
                    )}
                </div>


                    <div className={"lg:col-span-8 lg:col-start-3"}>

                        <select className={"form-input-text form-select w-full bg-brand-green-light"} onChange={e => setSelectedMaterial(e.target.value)}>
                            <option value="">Please select from list</option>

                            {chosenLocation.allowed_materials ? chosenLocation.allowed_materials.map(material =>
                                <option value={material} key={material}>{material}</option>
                            ) : (
                                <>
                                    <option value="Household items">Household items</option>
                                    <option value="Construction debris">Construction debris</option>
                                    <option value="Yard waste">Yard waste</option>
                                    <option value="Roofing materials">Roofing materials</option>
                                    <option value="Concrete/brick">Concrete/brick</option>
                                    <option value="Dirt">Dirt</option>
                                    <option value="Insulation">Insulation</option>
                                </>
                            )}

                            <option value="Other">Other</option>
                        </select>

                        {selectedMaterial === 'Other' && (
                            <textarea
                                className={'form-input-text mt-6 w-full bg-brand-green-light placeholder:text-brand-dark/70 placeholder:italic h-[185px] py-2'}
                                placeholder={'Please provide details of the material you are disposing of (optional)'}
                                name="materials"
                                value={otherMaterials || ''}
                                onChange={e => setOtherMaterials(e.target.value)}
                            />
                        )}
                    </div>


                {!simpleMode && (
                    <>
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <button className={"btn"} disabled={animating} onClick={handleNextStep}>
                                Next Step →
                            </button>
                        </div>
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <LocationContact location={chosenLocation}/>
                        </div>
                    </>
                )}

            </div>
        </div>
    )
}